import { useMutation } from '@tanstack/react-query';

import { Entity } from '../../../../types/utility';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postDocumentFormAction } from '../../requests/postDocumentFormAction';
import { DocumentParams } from '../../types/DocumentParams';

export const useDocumentFormAction = (documentParams: DocumentParams) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: postFormAction, ...rest } = useMutation({
    mutationFn: ({
      documentId,
      data,
      formIdentifier,
      action,
      path,
    }: {
      documentId: string;
      data: Entity;
      formIdentifier: string;
      action: string;
      path: string;
    }) =>
      postDocumentFormAction(
        constructPost,
        documentId,
        documentParams,
        data,
        formIdentifier,
        action,
        path,
      ),
  });

  return { postFormAction, ...rest };
};
